import { render, staticRenderFns } from "./ChatIconDisabled.vue?vue&type=template&id=37bc1003&scoped=true"
import script from "./ChatIconDisabled.vue?vue&type=script&lang=js"
export * from "./ChatIconDisabled.vue?vue&type=script&lang=js"
import style0 from "./ChatIconDisabled.vue?vue&type=style&index=0&id=37bc1003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc1003",
  null
  
)

export default component.exports